import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const Root = styled(Stack)({
  justifyContent: 'center',
  width: '100%'
});
